module.exports = __webpack_public_path__ + "img/Eagle_Home_0.937a9fc6.png";